import { Card } from "components/ui/card";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { AnimatePresence, motion } from "framer-motion";
import { t } from "i18next";

import { AlignJustify, ArrowRightLeft, Globe, Info, KeyRound, ListX, Settings, Smartphone, Trash2, UserRoundSearch, X } from "lucide-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RouteUrl } from "utils";

export default function SettingLeftSideContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isNavLinksVisible, setIsNavLinksVisible] = useState(false);
  const navLink = [
    {
      name: `${t("Profile Detail")}`,
      url: RouteUrl.ProfileDetail,
      icon: <Info />,
    },
    {
      name: `${t("Setting & Security")}`,
      url: RouteUrl.setting,
      icon: <Settings />,
    },
    {
      name: `${t("View Profile")}`,
      url: RouteUrl.viewProfile,
      icon: <UserRoundSearch />,
    },
    {
      name: `${t("Block Accounts")}`,
      url: RouteUrl.blockAccount,
      icon: <i className="fa-solid fa-user-slash fa-lg" />,
    },
    {
      name: `${t("Boring Accounts")}`,
      url: RouteUrl.boringAccount,
      icon: <i className="fa-solid fa-user-minus fa-lg" />,
    },
    // { name: "Sound Libraries", url: RouteUrl.soundLibraries, icon: <Music2 /> },
    {
      name: `${t("Interesting")}`,
      url: RouteUrl.interesting,
      icon: <i className="fa-regular fa-rectangle-list fa-lg" />,
    },
    // {
    //   name: "Request Verificatoin Account",
    //   url: RouteUrl.requestVerificationAccount,
    //   icon: <ShieldCheck />,
    // },
    {
      name: `${t("Change Password")}`,
      url: RouteUrl.changePassword,
      icon: <KeyRound />,
    },
    // { name: "Ship To Address", url: "", icon: <MapPin /> },
    {
      name: `${t("Delete Account")}`,
      url: RouteUrl.deleteAccount,
      icon: <Trash2 />,
    },
    {
      name: `${t("Desactivate Account")}`,
      url: RouteUrl.desActivateAccount,
      icon: <i className="fa-solid fa-person-circle-minus fa-lg" />,
    },
    {
      name: `${t("Switch Account")}`,
      url: RouteUrl.switchAccount,
      icon: <ArrowRightLeft />,
    },
    {
      name: `${t("Logged Devices")}`,
      url: RouteUrl.loggedDevices,
      icon: <Smartphone />,
    },
    { name: `${t("Language")}`, url: RouteUrl.language, icon: <Globe /> },
  ];

  function handleClickNavLink(link: string) {
    if (location.pathname !== link) {
      navigate(link);
    }
  }

  return (
    <>
      <ScrollArea className="hidden md:block md:w-[100px] lg:w-[310px] border-r-2 h-[calc(100vh-80px)] z-0">
        <div className="p-4 space-y-2">
          <h1 className="font-semibold text-lg hidden md:block">Account</h1>

          {navLink.map((link, index) => {
            return (
              <button
                key={index}
                onClick={() => handleClickNavLink(link.url)}
                className={`p-2 rounded-xl cursor-pointer w-full ${
                  location.pathname === link.url ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "hover:bg-accent hover:text-accent-foreground"
                }`}
              >
                <ul>
                  <li className="flex items-center justify-center lg:justify-start space-x-2 h-6">
                    <div className="flex items-center justify-center">{link.icon}</div>
                    <p className="text-md hidden lg:block">{link.name}</p> {/* Show text only on large screens */}
                  </li>
                </ul>
              </button>
            );
          })}
        </div>
        <ScrollBar orientation="vertical" />
      </ScrollArea>

      {/* Mobile Button NavLink */}
      <div className="fixed bottom-4 right-6 md:hidden z-[9999]">
        <motion.button
          className="p-3 rounded-full transition-colors shadow-md bg-gradient-to-r bg-primary text-white shadow-blue-500/50"
          onClick={() => setIsNavLinksVisible(!isNavLinksVisible)}
          animate={{ rotate: isNavLinksVisible ? 90 : 0 }}
          transition={{ duration: 0.3 }}
        >
          {isNavLinksVisible ? <X /> : <AlignJustify />}
        </motion.button>
      </div>

      {/* Displaying Nav Icons when toggled */}
      <AnimatePresence>
        {isNavLinksVisible && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-20 right-4 md:hidden z-[9999] space-y-2 w-16"
          >
            <Card className="p-1 flex flex-col justify-center items-center transition-colors bg-white text-gray-700 shadow-md dark:bg-card dark:text-white dark:shadow-lg">
              {navLink.map((link, index) => (
                <button
                  key={index}
                  onClick={() => handleClickNavLink(link.url)}
                  className={`p-2 rounded-xl cursor-pointer w-12 ${
                    location.pathname === link.url ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "hover:bg-accent hover:text-accent-foreground"
                  }`}
                >
                  <div className="flex items-center justify-center">
                    <div>{link.icon}</div>
                  </div>
                </button>
              ))}
            </Card>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
